module.exports = __webpack_public_path__ + "static/media/astronautSFoguinho.707e62f0.png";